import {
  selectOrganizationId,
  useGetOrganizationQuery,
} from '@carboncopyco/data';
import { useSelector } from 'react-redux';

export const usePoc = () => {
  const organizationId = useSelector(selectOrganizationId);
  const { data: organization } = useGetOrganizationQuery({
    id: String(organizationId),
  });
  return organization?.state === 'poc';
};
